/**
 * Env vars published to the browser — never add credentials (e.g. VITE_API_LOCALE).
 * Keep in sync with docker/40-render-runtime-config.sh.
 */
export const PUBLIC_RUNTIME_KEYS = [
  'VITE_MAPBOX_TOKEN',
  'VITE_MAP_DEFAULT_CENTER_LON',
  'VITE_MAP_DEFAULT_CENTER_LAT',
  'VITE_SPEEDTEST_DOWNLOAD_URL',
  'VITE_SPEEDTEST_UPLOAD_URL',
  'VITE_SPEEDTEST_DOWNLOAD_URL_2',
  'VITE_SPEEDTEST_UPLOAD_URL_2',
] as const;

export type PublicRuntimeKey = (typeof PUBLIC_RUNTIME_KEYS)[number];

export type RuntimeConfig = Partial<Record<PublicRuntimeKey, string>>;

/** Name of the global the runtime config is published under. */
export const RUNTIME_CONFIG_GLOBAL = '__ACS_CONFIG__';

/** Serialises the body of `/config.js`, escaping `<` so it is safe inline. */
export function serializeRuntimeConfig(config: RuntimeConfig): string {
  const json = JSON.stringify(config).replace(/</g, '\\u003c');
  return `window.${RUNTIME_CONFIG_GLOBAL}=${json};\n`;
}
